import { Building2, Home, Laptop } from "lucide-react";

const WORK_LOCATION_CONFIG: Record<string, { label: string; icon: typeof Building2 }> = {
  op_locatie: { label: "Op locatie", icon: Building2 },
  hybride: { label: "Hybride", icon: Laptop },
  remote: { label: "Remote", icon: Home },
};

interface WorkLocationBadgeProps {
  type: string | null | undefined;
  className?: string;
  size?: "sm" | "md";
}

export const WorkLocationBadge = ({ type, className, size = "sm" }: WorkLocationBadgeProps) => {
  if (!type) return null;
  if (size === "sm") return null; // Only show on detail page (md size)

  const config = WORK_LOCATION_CONFIG[type];
  if (!config) return null;

  const Icon = config.icon;

  if (size === "md") {
    return (
      <div className={`flex items-center gap-2 bg-muted/50 px-5 py-3 rounded-2xl border border-foreground/15 ${className || ""}`}>
        <Icon className="w-5 h-5 text-cyan-dark" />
        <span className="font-bold text-foreground">{config.label}</span>
      </div>
    );
  }

  return (
    <div className={`flex items-center gap-2 bg-foreground/5 rounded-xl px-3 py-2 border border-foreground/10 h-fit ${className || ""}`}>
      <Icon className="w-4 h-4 text-cyan" />
      <span className="text-sm font-bold text-foreground">{config.label}</span>
    </div>
  );
};
